import {
  GET_COUNTRIES_SETUP_START,
  GET_COUNTRIES_SETUP_SUCCESS,
  GET_CURRENCIES_SETUP_START,
  GET_CURRENCIES_SETUP_SUCCESS,
  GET_INTEGRATOR_SETUP_START,
  GET_INTEGRATOR_SETUP_SUCCESS,
  GET_LANGUAGES_SETUP_START,
  GET_LANGUAGES_SETUP_SUCCESS,
  RESET_STORE,
} from "./types";

const initialState = {
  detail: {
    id: null,
    name: "",
    test: false,
    loading: false,
    attributeCollection: {
      id: null,
      name: "",
    },
    jurisdiction: {
      id: null,
      name: "",
    },
  },
  languages: {
    supported: [],
    nonSupported: [],
    loading: false,
  },
  currencies: {
    results: [],
    loading: false,
  },
  countries: {
    allowedCountries: [],
    forbiddenCountries: [],
    loading: false,
  },
};

export default (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
  case GET_INTEGRATOR_SETUP_START:
    return {
      ...state,
      detail: {
        ...state.detail,
        loading: true,
      },
    };
  case GET_INTEGRATOR_SETUP_SUCCESS:
    return {
      ...state,
      detail: {
        ...state.detail,
        ...payload.detail,
        loading: false,
      },
    };
  case GET_LANGUAGES_SETUP_START:
    return {
      ...state,
      languages: {
        ...state.languages,
        loading: true,
      },
    };
  case GET_LANGUAGES_SETUP_SUCCESS:
    return {
      ...state,
      languages: {
        ...payload.languages,
        loading: false,
      },
    };
  case GET_CURRENCIES_SETUP_START:
    return {
      ...state,
      currencies: {
        ...state.currencies,
        results: [],
        loading: true,
      },
    };
  case GET_CURRENCIES_SETUP_SUCCESS:
    return {
      ...state,
      currencies: {
        ...payload.currencies,
        loading: false,
      },
    };
  case GET_COUNTRIES_SETUP_START:
    return {
      ...state,
      countries: {
        ...state.countries,
        results: [],
        loading: true,
      },
    };
  case GET_COUNTRIES_SETUP_SUCCESS:
    return {
      ...state,
      countries: {
        forbiddenCountries: payload.forbiddenCountries,
        allowedCountries: payload.allowedCountries,
        loading: false,
      },
    };
  case RESET_STORE:
    return initialState;
  default:
    return state;
  }
};
